import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../public/icons-v1_1";

type FilterChipColorVariant = "blue" | "gray";

const colorVariantStyles: Record<
  FilterChipColorVariant,
  { border: string; background: string; color: string }
> = {
  blue: {
    border: "0.5px solid #1272EF",
    background: "#F0F9FF",
    color: "#1272EF",
  },
  gray: {
    border: "0.5px solid #D4D4D1",
    background: "#F7F9FA",
    color: "#444440",
  },
};

interface Props {
  label: string;
  onRemove: () => void;
  colorVariant?: FilterChipColorVariant;
}

function FilterChip({ label, onRemove, colorVariant = "blue" }: Props) {
  const { border, background, color } = colorVariantStyles[colorVariant];

  return (
    <Flex
      alignItems={"center"}
      gap={"4px"}
      padding={"4px 8px"}
      borderRadius={"6px"}
      border={border}
      background={background}
    >
      <Text textStyle={"body-sm-medium"} color={color}>
        {label}
      </Text>
      <Flex
        as={"button"}
        alignItems={"center"}
        cursor={"pointer"}
        color={color}
        onClick={onRemove}
        aria-label={"remove filter"}
      >
        <CustomIcon src={"x"} width={14} height={14} />
      </Flex>
    </Flex>
  );
}

export default FilterChip;
